import { Link } from "react-router-dom";
import SEO from "../../components/SEO";

export default function CorporateAdvisors() {
  const corporateAdvisorsSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Corporate Advisors",
    "url": "https://www.thrombio.com.au/leadership/corporate-advisors",
    "mainEntity": {
      "@type": "Organization",
      "name": "Thrombio",
      "url": "https://www.thrombio.com.au/",
      "logo": "https://www.thrombio.com.au/thromBioInvert.png",
      "contactPoint": {
        "@type": "ContactPoint",
        "email": "info@thrombio.com.au"
      },
      "sameAs": [
        "https://www.linkedin.com/company/thrombioholdings"
      ]
    },
    "about": {
      "@type": "Organization",
      "name": "Thrombio",
      "description": "Thrombio is a drug discovery company dedicated to advancing the global standard of care for the treatment of stroke using novel anti-thrombotic drugs with unprecedented safety and efficacy."
    }
  };

  return (
    <div className="corporateAdvisorsBg">
      <SEO
        title="Corporate Advisors"
        description="Learn about our team of international leaders in stroke clinical trials, scientists with extensive drug development experience and businesspeople with more than 30 years' experience"
        keywords={['Corporate Advisors', 'Rod Jackson', 'Mithran Doraisamy', 'Business Strategy', 'Executive Coaching']}
        ogImage="/rodJackson.webp"
        schema={corporateAdvisorsSchema}
      />

      <div className="page-width px-12 pt-44">
        <div className="flex flex-col gap-4 md:gap-16">
          {/* Optimized H1 tag that preserves layout */}
          <div className="text-[4.8rem] font-bold leading-[5.2rem] tracking-[.19rem] drop-shadow-[0_4px_8.9px_#000]">
            <h1 className="sr-only">ThromBio Corporate Advisors: Leading Experts in Biotech and Stroke Therapy</h1>
            Leadership
          </div>
          {/* Optimized H2 tag that preserves layout */}
          <div className="drop-shadow-[0_4px_8.9px_#000] font-syne text-[3rem] font-bold leading-[3.6rem] tracking-[.15rem]">
            <h2 className="sr-only">Our Advisory Board: Pioneers in Stroke Treatment</h2>
            Corporate Advisors
          </div>
        </div>
      </div>
      <div className="pt-[130px] xl:pt-[90px] xl:pb-[200px] px-16 xl:px-[228px] 2xl:px-[450px] flex flex-col xl:grid grid-cols-2 items-center xl:items-start xl:justify-evenly gap-[115px] md:gap-[75px] corporateAdvisorsBg2">
        <div>
          <Link to="/leadership/rod-jackson" className="group">
            <div className="flex flex-col items-center group">
              <img 
                src="/rodJackson.webp" 
                alt="Rod Jackson, Senior Advisor - Financial Services and Business Leadership Expert" 
                className="mb-20 transition-transform duration-300 group-hover:scale-105 cursor-pointer" 
                width={241} 
                height={241} 
              />
              <div className="text-center text-white text-[3.1rem] font-medium leading-relaxed tracking-wider [text-shadow:_2px_4px_5px_rgb(0_0_0_/_1.00)] mb-[1.3rem]">
                Rod Jackson
              </div>
              <div className="text-center justify-start text-[#e0ffff] text-[1.9rem] font-medium leading-[2.6rem] tracking-[.096rem] [text-shadow:_2px_4px_5px_rgb(0_0_0_/_1.00)] mb-10">
                Senior Advisor
              </div>
            </div>
          </Link>
        </div>
        <img src="/1.2.svg" alt="Decorative divider" width={23} height={14} className="xl:hidden" />
        <div className="">
          <Link to="/leadership/mithran-doraisamy" className="group">
            <div className="flex flex-col items-center group">
              <img 
                src="/mithranDoraisamy.webp" 
                alt="Mithran Doraisamy, Strategic Consultant - Expert in Business Growth and Transformation" 
                className="mb-20 transition-transform duration-300 group-hover:scale-105 cursor-pointer" 
                width={241} 
                height={241} 
              />
              <div className="text-center text-white text-[3.1rem] font-medium leading-relaxed tracking-wider [text-shadow:_2px_4px_5px_rgb(0_0_0_/_1.00)] mb-[1.3rem]">
                Mithran Doraisamy
              </div>
              <div className="text-center justify-start text-[#e0ffff] text-[1.9rem] font-medium leading-[2.6rem] tracking-[.096rem] [text-shadow:_2px_4px_5px_rgb(0_0_0_/_1.00)] mb-10">
                Strategic Consultant
              </div>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
}